import type { ReactNode } from 'react'

import { Component } from 'react'

interface WebGLBoundaryProps {
    fallback: ReactNode
    children: ReactNode
}

interface WebGLBoundaryState {
    failed: boolean
}

/* Shows the still version when a 3D scene cannot start (no WebGL, lost context, driver error). */
export class WebGLBoundary extends Component<WebGLBoundaryProps, WebGLBoundaryState> {
    state: WebGLBoundaryState = { failed: false }

    static getDerivedStateFromError(): WebGLBoundaryState {
        return { failed: true }
    }

    componentDidCatch(error: unknown) {
        console.error('The 3D scene could not start, showing the still version:', error instanceof Error ? error.message : error)
    }

    render() {
        return this.state.failed ? this.props.fallback : this.props.children
    }
}

export const supportsWebGL = (): boolean => {
    try {
        const canvas = document.createElement('canvas')

        return Boolean(canvas.getContext('webgl2') || canvas.getContext('webgl'))
    }
    catch {
        return false
    }
}
